import { useQuery } from "@tanstack/react-query";
import {
  fetchProfileMatchingRoles,
  FetchProfileMatchingRolesParams,
  FetchProfileMatchingRolesResponse
} from "PFCore/services/profile";
import { QueryOptions } from "PFTypes";

import profileKeys from "./query_keys";

export const useProfileMatchingRoles = (
  params: FetchProfileMatchingRolesParams,
  options: QueryOptions<FetchProfileMatchingRolesResponse> = {}
) =>
  useQuery<FetchProfileMatchingRolesResponse>({
    queryKey: profileKeys.matchingRoles(params),
    queryFn: () => fetchProfileMatchingRoles(params),
    retry: false,
    ...options
  });
